import { memo } from "react";

import logo from "~/content/images/viedocTM.png";

// Reuse the real stylesheet rather than copying rules, so the replica cannot
// drift visually from the footer it is replicating.
import "~/components/Layout/Footer/Footer.css";
import "./PreviewAppFooter.css";

/**
 * Preview-only replica of `<Footer>` (Layout/Footer).
 *
 * The real footer fetches its copyright and version lines through
 * `useFetchFooter`, and /preview's contract is "no fetch, no API call" — the
 * iframe holds no session to fetch with. The preview shows the form as a
 * participant sees it, app chrome included, so the footer is replicated with
 * the real logo and grey placeholder bars where the fetched lines would be —
 * the same greeked treatment the Designer's preview mock uses.
 *
 * Markup mirrors `Footer` class-for-class so `Footer.css` styles it; the
 * placeholder block is aria-hidden because there is nothing to read.
 *
 * Memoized with no props: the previewed form re-renders `PreviewForm` on
 * every keystroke, and this subtree never changes.
 */
export const PreviewAppFooter = memo(function PreviewAppFooter() {
    return (
        <footer
            className="footer preview-app-footer"
            data-testid="preview-app-footer"
        >
            <img
                src={logo}
                alt="Viedoc"
                className="footer__logo"
                width="90px"
                height="40px"
            />
            <div className="preview-app-footer__links" aria-hidden="true">
                <span className="preview-app-footer__bar" />
                <span className="preview-app-footer__dot" />
                <span className="preview-app-footer__bar" />
                <span className="preview-app-footer__dot" />
                <span className="preview-app-footer__bar" />
            </div>
            <div
                className="preview-app-footer__bar preview-app-footer__line"
                aria-hidden="true"
            />
        </footer>
    );
});
